import React from 'react';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { t } from 'ttag';

import Form from '../../../components/Form';
import FormField from '../../../components/FormField';
import Loading from '../../../components/Loading';
import { GENDER_OPTIONS } from '../../../utils/enums';
import FormBox from '../../../components/FormBox';
import ChangePasswordDialog from '../../../components/ChangePassword';
import useApi from '../../../api';
import useCreateForm from '../../../hooks/useCreateForm';
import useEditForm from '../../../hooks/useEditForm';

const BaseForm = ({
  id,
  initial,
  edit,
  onSubmit,
  errors,
  showPasswordField,
}) => {
  const api = useApi();
  return (
    <Form onSubmit={onSubmit} initial={initial} errors={errors}>
      {({ data, change, errors, submit }) => (
        <Grid container spacing={4}>
          <Grid item sm={6}>
            <FormBox title={t`Основна інформація`}>
              <FormField
                required
                fullWidth
                query={api.schema.clubs.many()[0]}
                preInit={edit}
                dataKey='clubs'
                variables={{}}
                type='remoteSelect'
                margin='normal'
                label={t`Оберіть клуб`}
                id='clubId'
                name='clubId'
                variant='outlined'
                value={data.clubId}
                errors={errors.club_id}
                labelKey='fullName'
                onChange={change}
              />
              <FormField
                required
                fullWidth
                type='text'
                margin='normal'
                label={t`Прізвище`}
                id='lastName'
                name='lastName'
                autoComplete='lastName'
                variant='outlined'
                value={data.lastName}
                errors={errors.last_name}
                onChange={change}
              />
              <FormField
                required
                fullWidth
                type='text'
                margin='normal'
                label={t`Ім'я`}
                id='firstName'
                name='firstName'
                autoComplete='firstName'
                variant='outlined'
                value={data.firstName}
                errors={errors.first_name}
                onChange={change}
              />
              <FormField
                required
                fullWidth
                type='text'
                margin='normal'
                label={t`По-батькові`}
                id='middleName'
                name='middleName'
                autoComplete='middleName'
                variant='outlined'
                value={data.middleName}
                errors={errors.middle_name}
                onChange={change}
              />
              <FormField
                required
                fullWidth
                type='text'
                margin='normal'
                label={t`Email`}
                id='email'
                name='email'
                autoComplete='email'
                variant='outlined'
                value={data.email}
                errors={errors.email}
                onChange={change}
              />
              {showPasswordField && (
                <FormField
                  required
                  fullWidth
                  type='password'
                  margin='normal'
                  label={t`Пароль`}
                  id='password'
                  name='password'
                  autoComplete='password'
                  variant='outlined'
                  value={data.password}
                  errors={errors.password}
                  onChange={change}
                />
              )}
              <FormField
                required
                fullWidth
                type='select'
                margin='normal'
                label={t`Стать`}
                id='gender'
                name='gender'
                autoComplete='gender'
                variant='outlined'
                value={data.gender}
                errors={errors.gender}
                options={GENDER_OPTIONS}
                onChange={change}
              />
              <Button
                style={{ margin: '20px 0 20px 0' }}
                margin='normal'
                type='button'
                fullWidth
                variant='contained'
                color='primary'
                onClick={submit}
              >
                {t`Зберегти`}
              </Button>
            </FormBox>
          </Grid>
          {edit && id && (
            <Grid item sm={6}>
              <FormBox title={t`Налаштування`}>
                <br />
                <ChangePasswordDialog userId={id} />
              </FormBox>
            </Grid>
          )}
        </Grid>
      )}
    </Form>
  );
};

const getInitialData = (row) => ({
  clubId: row.clubId || '',
  firstName: row.firstName || '',
  lastName: row.lastName || '',
  middleName: row.middleName || '',
  email: row.email || '',
  gender: row.gender || undefined,
  password: '',
});

export const EditForm = () => {
  const api = useApi();
  const { id, loading, data, onSubmit, errors } = useEditForm({
    schema: api.schema.superManagers,
    router: api.router.superManagers,
  });

  if (loading) return <Loading />;

  return (
    <>
      <h2>{t`Редагувати менеджера: ${data.fullName}`}</h2>
      <Paper>
        <Box m={4}>
          <BaseForm
            id={id}
            initial={getInitialData(data)}
            onSubmit={onSubmit}
            errors={errors}
            edit
            showPasswordField={false}
          />
        </Box>
      </Paper>
    </>
  );
};

export const CreateForm = () => {
  const api = useApi();
  const { loading, onSubmit, errors } = useCreateForm({
    schema: api.schema.superManagers,
    router: api.router.superManagers,
  });

  if (loading) return <Loading />;

  return (
    <>
      <h2>{t`Додати менеджера`}</h2>
      <Paper>
        <Box m={4}>
          <BaseForm
            initial={getInitialData({})}
            onSubmit={onSubmit}
            errors={errors}
            edit={false}
            showPasswordField
          />
        </Box>
      </Paper>
    </>
  );
};
